module.exports = __webpack_public_path__ + "img/experiential-text.ae246f5b.svg";